import React from "react";

export type SeverityType = "success" | "error" | "warning" | "info" | null;
type AlertState = {
  message?: string;
  severity?: SeverityType;
};
type AlertAction = AlertState;
type AlertDispatch = (action: AlertAction) => void;
type AlertProviderProps = { children: React.ReactNode };

const AlertContext = React.createContext<AlertState | undefined>(undefined);
const AlertDispatchContext = React.createContext<AlertDispatch | undefined>(undefined);

const alertReducer = (state: AlertState, action: AlertAction) => ({ ...state, ...action });

const AlertProvider = ({ children }: AlertProviderProps) => {
  const [state, dispatch] = React.useReducer(alertReducer, {});
  return (
    <AlertContext.Provider value={state}>
      <AlertDispatchContext.Provider value={dispatch}>{children}</AlertDispatchContext.Provider>
    </AlertContext.Provider>
  );
};

const useAlert = (): [AlertState, AlertDispatch] => {
  const state = React.useContext(AlertContext);
  const dispatch = React.useContext(AlertDispatchContext);
  return [state, dispatch];
};

const useAlertDispatch = (): AlertDispatch => React.useContext(AlertDispatchContext);

export { AlertProvider, useAlert, useAlertDispatch };
